
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../../honcierge-api"
import DeleteButtonWithConfirm from "@/components/DeleteButtonWithConfirm.vue"
import { DataTableHeader } from "vuetify/types"

import { AxiosError } from "axios"
import { Article } from "types/index"

@Component({ components: { DeleteButtonWithConfirm } })
export default class Edit extends Vue {
  @Prop({ default: null })
  private id!: number | null

  private articles: Article[] = []

  private dialog = false

  private script = ""
  private description = ""
  private isGoogle = false

  // rules for form
  private scriptRules = [(script: number) => !!script || "スクリプトは必須です"]
  private descriptionRules = [
    (description: string) => !!description || "詳細は必須です",
  ]

  get articleHeaders(): DataTableHeader[] {
    return [
      { text: "編集", value: "", sortable: false },
      { text: "ステータス", value: "status" },
      { text: "公開日", value: "publishedAt" },
      { text: "コンシェルジュ", value: "writer" },
      { text: "画像", value: "thumbnail", sortable: false },
      { text: "更新日時", value: "updatedAt" },
    ]
  }

  public createOrUpdateInlineAdvertisement(): void {
    if (!this.validate()) {
      return
    }
    if (this.id !== null) {
      api
        .updateInlineAdvertisement({
          id: this.id,
          script: this.script,
          description: this.description,
          isGoogle: this.isGoogle,
        })
        .then(() => {
          this.emitInlineAdvertisement()
          this.$toasted.success("インライン広告を更新しました")
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            this.$toasted.error(e.response.data.messages)
          }
        })
    } else {
      api
        .createInlineAdvertisement({
          script: this.script,
          description: this.description,
          isGoogle: this.isGoogle,
        })
        .then(() => {
          this.emitInlineAdvertisement()
          this.$toasted.success("インライン広告を新規作成しました")
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            this.$toasted.error(e.response.data.messages)
          }
        })
    }
  }

  @Emit("emitInlineAdvertisement")
  private emitInlineAdvertisement() {
    this.close()
  }

  private close() {
    this.dialog = false
    this.clear()
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private init() {
    this.script = ""
    this.description = ""
    this.isGoogle = false
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof Edit>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof Edit>
    return form.resetValidation()
  }

  private existWriterThumbnail(writer: Article["writer"]): boolean {
    if (writer) {
      return (
        writer &&
        writer.thumbnail &&
        writer.thumbnail.filename !== "" &&
        writer.thumbnail.url !== ""
      )
    } else {
      return false
    }
  }

  private existArticleThumbnail(thumbnail: Article["thumbnail"]): boolean {
    return thumbnail && thumbnail.filename !== "" && thumbnail.url !== ""
  }

  private deleteInlineAdvertisement() {
    if (this.id !== null) {
      if (
        confirm(
          "本当に削除しますか?\n削除すると記事本文からインライン広告が除去されます\n紐付いている記事は編集画面で確認できます"
        )
      ) {
        api
          .deleteInlineAdvertisement(this.id)
          .then(() => {
            this.emitInlineAdvertisement()
          })
          .catch((error) => {
            console.log(error.stack)
            this.$toasted.error("インライン広告の削除に失敗しました")
          })
      }
    }
  }

  public async open() {
    if (this.id !== null) {
      try {
        const response = await api.getInlineAdvertisement(this.id)
        const inlineAdvertisement = response.data.inlineAdvertisement
        this.script = inlineAdvertisement.script
        this.description = inlineAdvertisement.description
        this.isGoogle = inlineAdvertisement.isGoogle
      } catch {
        this.$toasted.error("インライン広告の取得に失敗しました")
      }

      try {
        const fields: [string, ...string[]] = [
          "id",
          "status",
          "publishedAt",
          "writer",
          "thumbnail",
          "updatedAt",
        ]
        const response = await api.getArticles({
          fields,
          inlineAdvertisementId: this.id,
          withoutPagination: true,
        })
        this.articles = response.data.articles
      } catch {
        this.$toasted.error("インライン広告に紐付く記事の取得に失敗しました")
      }
    }
    this.dialog = true
  }
}
